module.exports = __webpack_public_path__ + "static/media/img4.e77a5906.jpg";